import {NgModule} from "@angular/core";

import {MinioUrlPipe} from "./pipe/minio-url.pipe";
import {PhoneNumberPipe} from "./pipe/phone-number.pipe";

@NgModule({
    declarations: [
        MinioUrlPipe,
        PhoneNumberPipe
    ],
    imports: [],
    exports: [
        MinioUrlPipe,
        PhoneNumberPipe
    ]
})
export class SharedModule {

}
